export default __webpack_public_path__ + "static/docker-5489762068778f906931c6f3cdd79d6d.svg";